import * as angular from 'angular';
import * as _ from 'underscore';

class DiscountForStaffTabList {}

angular.module('naut').component('discountForStaffTabList', {
    template: require('./discount-for-staff-tab-list.component.html'),
    controller: DiscountForStaffTabList,
    controllerAs: 'ctrl'
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/discountForStaff/tabs-list/discount-for-staff-tab-list.component.ts